<script setup>
// core
import {computed, ref} from "vue";
import {useStore} from "vuex";

// components
import ButtonLoading from "@/components/Recurring/ButtonLoading.vue";

const store = useStore()
const inputRef = ref(null)

const link = computed(() => store.state.dialogParams?.link ?? '')
const messenger = computed(() => store.state.dialogParams?.messenger ?? 'Viber')

const onCopy = () => {
    inputRef.value.select()
    document.execCommand("copy")

    store.commit("setToastContent", {
        status: "success",
        description: "page.generation.copy_link",
    })
    store.commit("closeDialog")
}
</script>

<template>
    <slot name="header_close"/>

    <div class="wrapper_dialog">
        <h3 class="title">{{ $t('page.generation.title') }}</h3>

        <div class="content">
            <div class="field">
                <p class="subtitle">{{ $t('page.generation.subtitle') }}</p>
                <input
                    ref="inputRef"
                    type="text"
                    readonly
                    :value="link"
                    @click="(e) => e.target.select()"
                />
            </div>

            <p class="confirm">{{ $t('page.generation.subtitle1') }}</p>
            <p class="confirm">{{ $t('page.generation.subtitle2', {messenger}) }}</p>

            <div class="action_container">
                <ButtonLoading @click="onCopy">
                    {{ $t('page.generation.copyButton') }}
                </ButtonLoading>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@use "@/styles/dialog-form.scss";

input {
    padding-right: 22px;
    text-overflow: ellipsis;
}
</style>
